const style = {
  header: {
    marginTop: '-68px',
    minHeight: '68px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #c4c4c4',
  },

  top: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#354052',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: '0 6px',
  },
  count: {
    display: 'flex',
    alignItems: 'center',
  },

  countIndicatorWrapper: {
    height: '14px',
  },

  content: {
    width: '100%',
  },

  share: {
    cursor: 'pointer',
    display: 'flex',
  },
  mail: {
    cursor: 'pointer',
    marginRight: '6px',
  },
  title: {
    width: '120px',
    textAlign: 'center',
  },
  titleWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: '13px',
  },
}

export default style
